import { ScaleTypes } from './charts.model';
import { Injectable } from '@angular/core';
import { scaleSequential } from 'd3-scale';

@Injectable({
  providedIn: 'root',
})
export class ChartsService {
  constructor() {}

  getColorScale(
    dataLength: number,
    scale: ScaleTypes,
    interpolation?: (t: number) => string
  ) {
    let color;
    switch (scale) {
      case ScaleTypes.SEQUENTIAL: {
        color = scaleSequential(interpolation).domain([0, dataLength]);
        break;
      }
    }
    return color;
  }
}
